var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.63867 8.78247V18.8992C4.64954 19.639 4.93062 20.3445 5.42124 20.8635C5.91185 21.3825 6.57268 21.6734 7.2611 21.6734C7.94953 21.6734 8.61035 21.3825 9.10097 20.8635C9.59159 20.3445 9.87266 19.639 9.88354 18.8992L9.89204 5.6388C9.89918 5.0065 9.78947 4.37896 9.56926 3.79257C9.34905 3.20619 9.02273 2.6726 8.60922 2.22276C8.1957 1.77292 7.70322 1.41577 7.16031 1.17201C6.61741 0.928252 6.03488 0.802734 5.4465 0.802734C4.85812 0.802734 4.2756 0.928252 3.73269 1.17201C3.18979 1.41577 2.6973 1.77292 2.28378 2.22276C1.87027 2.6726 1.54395 3.20619 1.32374 3.79257C1.10354 4.37896 0.993821 5.0065 1.00096 5.6388V18.9885C0.988973 19.8787 1.14176 20.7625 1.45044 21.5887C1.75912 22.4148 2.21753 23.1668 2.79903 23.8009C3.38052 24.4349 4.0735 24.9384 4.83766 25.2821C5.60183 25.6258 6.42193 25.8027 7.25031 25.8027C8.07868 25.8027 8.89879 25.6258 9.66295 25.2821C10.4271 24.9384 11.1201 24.4349 11.7016 23.8009C12.2831 23.1668 12.7415 22.4148 13.0502 21.5887C13.3589 20.7625 13.5116 19.8787 13.4997 18.9885V6.51368",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attachIcon.603a9f062b42c44578dd138f0d6720b5.svg";
export { ForwardRef as ReactComponent };